import validateUrl from './validateUrl';

/**
 * return a list of problems
 **/
export default (endEnabled, redirectUrl) => {
  const url = redirectUrl || '';

  if (!endEnabled) {
    if (!url.length) {
      return ['No redirect URL'];
    }
    if (!validateUrl(url)) {
      return [
        'Bad redirect URL. Be sure it starts with "http://" or "https://"',
      ];
    }
  }
  return []; // no issues found
};
